import React from 'react';
import PropTypes from 'prop-types';
import Card from 'common/components/card';
import CardContent from 'common/components/card-content';
import CardHeader from 'common/components/card-header';
import SummaryFigure from 'common/components/summary-figure';
import {getIconName} from 'common/utils/resource-icon-util';
import './index.scss';

export default class SummaryCard extends React.Component {
  static propTypes = {
    connectDragSource: PropTypes.func,
    data: PropTypes.array.isRequired,
    disableConfig: PropTypes.bool,
    forExport: PropTypes.bool,
    meta: PropTypes.object.isRequired,
    name: PropTypes.string.isRequired,
    priorityWarnings: PropTypes.array,
    reportId: PropTypes.number,
    warnings: PropTypes.array,
  };

  static defaultProps = {
    connectDragSource: (x) => x,
    disableConfig: false,
    forExport: false,
  };

  render() {
    return (
      <div className={'SummaryCard'}>
        <Card>
          {this.props.connectDragSource(
            <div>
              <CardHeader
                disableConfig={this.props.disableConfig}
                disableDownloadCsv={true}
                disableDownloadPointsCsv={true}
                priorityWarnings={this.props.priorityWarnings}
                reportId={this.props.reportId}
                subtitle={this.props.meta.period.displayName}
                title={this.props.name}
                warnings={this.props.warnings}
              />
            </div>,
          )}
          <CardContent>
            {this.props.data.map(({type, title, unit, value}) => (
              <div className={'SummaryCardItem'} key={type}>
                <SummaryFigure
                  icon={getIconName(type, 'resource-default')}
                  iconUseImg={this.props.forExport}
                  title={title}
                  units={unit.shortName}
                  value={value}
                />
              </div>
            ))}
          </CardContent>
        </Card>
      </div>
    );
  }
}
